<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import Form from '../form/Form';
import FormSaveBtn from '../form/FormSaveBtn';

const props = defineProps({
    modal: Object,
    options: Object
});

const emit = defineEmits(['hide-modal']);

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const router = proxy.$router;

// --- State ---

const formId = ref(null);
const tableName = 'modulecomponents';
const id = 0;
const isForm = props.options?.isForm ?? false;

// --- Computed ---

const modalTitle = computed(() => isForm ? 'New form' : 'New collection');

// --- Methods ---

const onSave = (obj) => {
    const newId = obj.id;

    // 1. Reload global components list
    store.dispatch('components/init')
        .finally(() => {
            // 2. Highlight new component in UI
            store.commit('navigationComponent', obj.tableName);

            // 3. Automated Setup for Form types
            if (isForm) {
                store.dispatch('componentStructure/init').then(() => {
                    const structure = store.getters['componentStructure/get'](newId);
                    const createdDateField = structure.find(o => o.columnName === 'createdDate');

                    if (createdDateField) {
                        store.dispatch('itemData/update', {
                            tableName: 'modulestructure',
                            id: createdDateField.id,
                            data: { browser: 1 },
                        });
                    }
                });
            }

            // 4. Close Modal
            emit('hide-modal');

            // 5. Reload Fieldsets and Navigate to Field Editor
            store.dispatch('componentFields/reloadFieldsets').then(() => {
                router.push({
                    name: 'componentFields',
                    params: {
                        component: obj.tableName,
                        fieldId: newId
                    }
                });
            });
        });
};

const createForm = () => {
    formId.value = `form:${tableName}:${id}`;

    // Link formId back to the modal object for external tracking
    if (props.modal) {
        props.modal.formId = formId.value;
    }

    store.dispatch('forms/createForm', {
        tableName,
        id,
        onSave,
        fieldNames: ['title'],
        currentData: {
            addNew: 1,
            useArchive: 1,
            allowFormAccess: isForm ? 1 : 0,
            deleteOption: 1,
            showStatus: isForm ? 0 : 1,
            isEditable: 1,
            navigationGroup: isForm ? 'Forms' : 'Add ons',
            roles: 1,
            rolesGroup: isForm ? 'Forms' : 'Add ons',
            updateOption: 1,
            listing: isForm ? 0 : 1,
            enableCache: 1
        }
    });
};

// --- Lifecycle ---

onMounted(() => {
    createForm();
});
</script>

<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ modalTitle }}</h4>
                <button type="button" class="btn-close" @click="$emit('hide-modal')" aria-label="Close"></button>
            </div>

            <div v-if="formId" class="modal-body">
                <Form :form-id="formId"/>

                <footer class="text-center mt-3">
                    <FormSaveBtn :button-text="'Save'" :form-id="formId"/>
                </footer>
            </div>

            <div class="modal-footer"></div>
        </div>
    </div>
</template>